import React, { PropsWithChildren, useCallback, useMemo, useState } from 'react';
import { DossierOpenSearch } from '@europrocurement/l2d-domain';
import DossierActionContext, { DossierAction } from './DossierActionContext';

const DossierActionProvider: React.FunctionComponent<PropsWithChildren> = function ({ children }) {
    const [dossiers, setDossiers] = useState<Array<DossierOpenSearch>>([]);
    const [currentAction, setCurrentAction] = useState<DossierAction>();
    const [dossiersUpdated, setDossiersUpdated] = useState<Array<DossierOpenSearch>>([]);
    // Used to catch an update on action validation
    const [updatingDossier, setUpdatingDossier] = useState<boolean>(false);

    const triggerAction = useCallback(
        (action: DossierAction, selectedDossiers: Array<DossierOpenSearch>) => {
            setCurrentAction(action);
            setDossiers(selectedDossiers);
            setDossiersUpdated([]);
        },
        [],
    );

    const cancelCurrentAction = useCallback(() => {
        setCurrentAction(undefined);
        setDossiers([]);
    }, []);

    const refreshDossiers = useCallback(() => {
        setUpdatingDossier((value) => !value);
    }, []);

    const confirmCurrentAction = useCallback(() => {
        setCurrentAction(undefined);
        setDossiersUpdated(dossiers);
        setDossiers([]);
        refreshDossiers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dossiers]);

    const contextValue = useMemo(
        () => ({
            dossiers,
            currentAction,
            dossiersUpdated,
            setDossiersUpdated,
            triggerAction,
            cancelCurrentAction,
            confirmCurrentAction,
            refreshDossiers,
            updatingDossier,
        }),
        [
            dossiers,
            currentAction,
            dossiersUpdated,
            setDossiersUpdated,
            triggerAction,
            cancelCurrentAction,
            confirmCurrentAction,
            refreshDossiers,
            updatingDossier,
        ],
    );

    return (
        <DossierActionContext.Provider value={contextValue}>
            {children}
        </DossierActionContext.Provider>
    );
};

export default DossierActionProvider;
